import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import "./index.scss";

export const ListItem = ({ title, ...props }: DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) => {
  return <button className="ListItem" {...props}>
    {title}
  </button>;
};
